
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';

const TEST_ID = 'Kloans-Loan-LoanAutopayDisableModal';

@Component
export default class LoanAutopayDisableModal extends Vue {
	public TEST_ID = TEST_ID;

	public isLoading = false;

	public isShown = false;

	@Prop({ default: { isShown: false, isLoading: false } })
	public state!: ModalState;

	@Emit('disable')
	// eslint-disable-next-line class-methods-use-this
	public emitDisable(): boolean {
		return true;
	}

	@Watch('state')
	public watchState(state: { isShown: boolean; isLoading: boolean }): void {
		this.isShown = state.isShown;
		this.isLoading = !!state.isLoading;
	}

	public close(): void {
		this.isShown = false;
		this.isLoading = false;
	}
}
